import useConvert from 'hooks/analytics/googleTagManager/useConvert'

const Convert = () => {
  useConvert()

  return null
}

export default Convert
